export const validateEmail = (email?: string): boolean => {
  const isValidEmail = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/g;

  if (email && email.match(isValidEmail)) {
    return true;
  }
  return false;
};
